import { render, staticRenderFns } from "./IconQr.vue?vue&type=template&id=b09ceae2"
import script from "./IconQr.vue?vue&type=script&lang=ts"
export * from "./IconQr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports